module.exports = __webpack_public_path__ + "static/img/img-gx.a0b7696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-gx.jpg
// module id = 4bHK
// module chunks = 0